'use client';

// Import Next.js Image component but use conditionally
import NextImage from 'next/image';
import { useState } from 'react';

export default function CustomImage({
  src,
  alt = '',
  width,
  height,
  className = '',
  priority = false,
  fill = false,
  sizes,
  ...props
}) {
  const [imgError, setImgError] = useState(false);
  
  // Ensure the source is a valid path
  const getImageSource = () => {
    if (!src || imgError) return '/placeholder.png';
    
    // If it's an absolute URL or data URL, use as is
    if (src.startsWith('http') || src.startsWith('data:')) return src;
    
    // For static export, ensure paths are correct
    // Remove any leading ./ that might cause issues
    let cleanSrc = src;
    if (cleanSrc.startsWith('./')) {
      cleanSrc = cleanSrc.substring(2);
    }
    
    // Ensure relative paths start with a slash for consistency
    return cleanSrc.startsWith('/') ? cleanSrc : `/${cleanSrc}`;
  };

  const imageSource = getImageSource();
  
  // Handle image error
  const handleError = () => {
    console.error(`Error loading image: ${imageSource}`);
    setImgError(true);
  };
  
  // Set default dimensions
  const imgWidth = width || (fill ? undefined : 500);
  const imgHeight = height || (fill ? undefined : 300);
  
  // Use standard img tag for static export
  return (
    <div 
      className={`relative ${className}`} 
      style={{
        width: fill ? '100%' : width,
        height: fill ? '100%' : height,
        position: fill ? 'relative' : 'relative',
      }}
    >
      <img
        src={imageSource}
        alt={alt || 'Image'}
        width={imgWidth}
        height={imgHeight}
        className={`${fill ? 'w-full h-full' : ''} ${className}`}
        onError={handleError}
        loading={priority ? 'eager' : 'lazy'}
        {...props}
      />
    </div>
  );
}
